import React from 'react';

export default function Venus() {
  return <div>Venus form</div>;
}
